import React from 'react'

import { HeadContent } from '@fourthwall/components'

import { StorageLimits } from './modules/StorageLimits'
import { SubscriptionPlan } from './modules/SubscriptionPlan'

export const Plan = () => {
  return (
    <>
      <HeadContent title="Plan &ndash; Settings" />
      <SubscriptionPlan />
      <StorageLimits />
    </>
  )
}
